import { lazy, FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { RouteObject } from 'react-router';
// import LayoutV1 from '../layout/LayoutV1';
import WrapperRouteComponent from './config';
import importRetry from './importRetry';
import Layout from '../layout/Layout';
import Spotter from '../modules/analytic/thoughtspot/spotter';

const NotFound = lazy(() => importRetry(() => import(/* webpackChunkName: "404'" */ '../common/pages/404')));
const Liveboard = lazy(() => importRetry(() => import(/* webpackChunkName: "liveboardTS'" */ '../modules/analytic/thoughtspot/liveboard')));
const FullApp = lazy(() => importRetry(() => import(/* webpackChunkName: "fullTS'" */ '../modules/analytic/thoughtspot/full')));
const Search = lazy(() => importRetry(() => import(/* webpackChunkName: "searchTS'" */ '../modules/analytic/thoughtspot/search')));
const Chat = lazy(() => importRetry(() => import(/* webpackChunkName: "chat'" */ '../modules/analytic/chat/container/chat')));

const routeList: RouteObject[] = [
  {
    path: '/',
    element: <WrapperRouteComponent element={<Layout />} />,
    children: [
      {
        path: "/",
        element: <WrapperRouteComponent element={<Liveboard />}  />,
      },
      {
        path: "/full",
        element: <WrapperRouteComponent element={<FullApp />}  />,
    
      },
      {
        path: "/search",
        element: <WrapperRouteComponent element={<Search />}  />,
      },
      {
        path: "/spotter",
        element: <WrapperRouteComponent element={<Spotter />}  />,
      },
      {
        path: "/chat",
        element: <WrapperRouteComponent element={<Chat />}  />,
      },
      {
        path: '*',
        element: <WrapperRouteComponent element={<NotFound />} titleId="user.title.notFound" auth />,
      },
    ],
  },
];

const RenderRouter: FC = () => {
  const element = useRoutes(routeList);
  return element;
};

export default RenderRouter;
